// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Lexend', 'Lexend Fallback'","fontStyle":"normal"},"className":"__className_7511d4"};